/**
 * Moderation Topic Detail Header Section
 *
 * Displays hero section with topic information
 */

import { CommunityHeader } from '@core/components';
import type { ModerationCommunity } from '@moderation/domain/ModerationCommunity';
import { Heading } from '@soteria/design-system-ve';

import * as styles from './ModerationTopicDetailHeaderSection.css';

interface ModerationTopic {
  id: string;
  name: string;
  description: string;
}

interface ModerationTopicDetailHeaderSectionProps {
  community: ModerationCommunity | null;
  topic: ModerationTopic | null;
  isLoading: boolean;
}

export function ModerationTopicDetailHeaderSection({ community: _community, topic, isLoading }: ModerationTopicDetailHeaderSectionProps) {
  if (isLoading || !topic) {
    return (
      <CommunityHeader
        v1Component={
          <div className={styles.heroSection}>
            <div className={styles.heroOverlay} />
            <div className={styles.heroContent}>
              <div className={styles.loadingState}>Loading...</div>
            </div>
          </div>
        }
        v2Props={{
          isLoading: true,
          title: '',
        }}
      />
    );
  }

  // V1: Original implementation
  const v1Component = (
    <div className={styles.heroSection} data-testid="moderation-topic-header-v1">
      <div className={styles.heroOverlay} />

      <div className={styles.heroContent}>
        <div className={styles.topicHeader}>
          <Heading className={styles.topicTitle} level="h1">
            {topic.name}
          </Heading>
          <p className={styles.topicDescription}>{topic.description}</p>
        </div>
      </div>
    </div>
  );

  // V2: Uses title-only variant with subtitle for topic description
  return (
    <CommunityHeader
      v1Component={v1Component}
      v2Props={{
        'data-testid': 'moderation-topic-header-v2',
        subtitle: topic.description,
        title: topic.name,
      }}
    />
  );
}
